//
//
//
//
//
//
//
//
//
//
//
//
//
import cn2011 from '@views/online/data/cn2011.vue';
import cn2051 from '@views/online/data/cn2051.vue';
import cn2061 from '@views/online/data/cn2061.vue';
export default {
  name: 'realTimeData',
  data: function data() {
    return {
      reportType: '1'
    };
  },
  props: ['siteId', 'showSiteTree'],
  components: {
    cn2011: cn2011,
    cn2051: cn2051,
    cn2061: cn2061
  },
  created: function created() {},
  watch: {},
  methods: {}
};